var _rect, _text, _g, _path, _rect2, _circle, _circle2, _text2, _path2, _g2, _rect3, _circle3, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentSystemDefinitionConnectedOperatingModelDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 460,
    viewBox: "0 0 720 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Connected custom intelligent system model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 458,
    rx: 28,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 44,
    fill: "#74BDFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.7
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42,
    dy: 0
  }, "YOUR OPERATION"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 75,
    width: 160,
    height: 64,
    rx: 14,
    fill: "#0B2340",
    stroke: "#1768AC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 107,
    r: 13,
    fill: "#087CFF",
    fillOpacity: 0.15,
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 108h12M70 102v12",
    stroke: "#74BDFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 102,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 0
  }, "PEOPLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 16
  }, "Roles and accountability")), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 158,
    width: 160,
    height: 64,
    rx: 14,
    fill: "#32142A",
    stroke: "#A42C63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 190,
    r: 13,
    fill: "#FF2775",
    fillOpacity: 0.15,
    stroke: "#FF2775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 186h14M63 194h14",
    stroke: "#FF91BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 185,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 0
  }, "PROCESS"), /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 16
  }, "Workflow and handovers")), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 241,
    width: 160,
    height: 64,
    rx: 14,
    fill: "#0D302E",
    stroke: "#198C70"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 273,
    r: 13,
    fill: "#30D6A1",
    fillOpacity: 0.15,
    stroke: "#30D6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 269h14v9H63z",
    fill: "none",
    stroke: "#75F0CA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 93,
    y: 268,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 0
  }, "DATA"), /*#__PURE__*/React.createElement("tspan", {
    x: 93,
    dy: 16
  }, "Evidence and context")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202 107h72M202 190h72M202 273h72",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 76,
    width: 210,
    height: 230,
    rx: 25,
    fill: "#07162B",
    stroke: "#087CFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 190,
    r: 72,
    fill: "#07152A",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 190,
    r: 56,
    fill: "none",
    stroke: "#FF2775",
    strokeOpacity: 0.42,
    strokeDasharray: "5 8"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 170,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 18,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 380,
    dy: 0
  }, "CONNECTED"), /*#__PURE__*/React.createElement("tspan", {
    x: 380,
    dy: 22
  }, "INTELLIGENCE"), /*#__PURE__*/React.createElement("tspan", {
    x: 380,
    dy: 22
  }, "LAYER"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M485 107h54M485 190h54M485 273h54",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 75,
    width: 140,
    height: 64,
    rx: 14,
    fill: "#0D2C50",
    stroke: "#1768AC"
  }), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 103,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 562,
    dy: 0
  }, "AUTOMATION"), /*#__PURE__*/React.createElement("tspan", {
    x: 562,
    dy: 16
  }, "Routine action")), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 158,
    width: 140,
    height: 64,
    rx: 14,
    fill: "#302712",
    stroke: "#9A7425"
  }), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 186,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 562,
    dy: 0
  }, "DECISIONS"), /*#__PURE__*/React.createElement("tspan", {
    x: 562,
    dy: 16
  }, "Human-owned action")), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 241,
    width: 140,
    height: 64,
    rx: 14,
    fill: "#0D302E",
    stroke: "#198C70"
  }), /*#__PURE__*/React.createElement("text", {
    x: 562,
    y: 269,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 562,
    dy: 0
  }, "VISIBILITY"), /*#__PURE__*/React.createElement("tspan", {
    x: 562,
    dy: 16
  }, "Live operational view")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 346,
    width: 638,
    height: 70,
    rx: 16,
    fill: "#10243E",
    stroke: "#2B5A85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 381,
    r: 6,
    fill: "#30D6A1"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 375,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 780,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 89,
    dy: 0
  }, "ONE OPERATIONAL ENVIRONMENT"), /*#__PURE__*/React.createElement("tspan", {
    x: 89,
    dy: 18
  }, "Designed around your process, controls and performance goals."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentSystemDefinitionConnectedOperatingModelDesktop);
export default __webpack_public_path__ + "static/media/custom-development-system-definition-connected-operating-model-desktop.3c0f6a5376970ee4b8a5f9bbc9923a46.svg";
export { ForwardRef as ReactComponent };